<template>
	<e-select
		track-by="tiers_id"
		label="tiers_rs"
		v-model="searchValue"
		:options="options"
		:placeholder="$t('global.ecrire_pour_rechercher')"
		:loading="isLoading"
		:sortable="false"
		:internal-search="false"
		@search-change="onSearch"
		@select="searchTiers"
		@input="searchTiers"
		ref="input"
		:disabled="disabled"
	>
		<template v-if="option.tiers_rs && option.tiers_postalcode" slot="singleLabel" slot-scope="{ option }">
			{{ option.tiers_rs }} ({{ option.tiers_postalcode }} {{ option.tiers_town }})
			<span v-if="with_tags" class="tag-manage tag-select"> <span v-for="tag in option.tiers_tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags"></span> </span>
		</template>
		<template v-else-if="option.tiers_rs" slot="singleLabel" slot-scope="{ option }">
			{{ option.tiers_rs }}
			<span v-if="with_tags" class="tag-manage tag-select"> <span v-for="tag in option.tiers_tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags"></span> </span>
		</template>
		<template v-if="option.tiers_rs && option.tiers_postalcode" slot="option" slot-scope="{ option }">
			{{ option.tiers_rs }} ({{ option.tiers_postalcode }} {{ option.tiers_town }})
			<span v-if="with_tags" class="tag-manage tag-select"> <span v-for="tag in option.tiers_tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags"></span> </span>
		</template>
		<template v-else-if="option.tiers_rs" slot="option" slot-scope="{ option }">
			{{ option.tiers_rs }}
			<span v-if="with_tags" class="tag-manage tag-select"> <span v-for="tag in option.tiers_tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags"></span> </span>
		</template>
		<template slot="noOptions">{{ $t('global.write_to_search') }}</template>
		<template slot="noResult">{{ $t('global.no_result') }}</template>
	</e-select>
</template>

<script>
import _debounce from 'lodash/debounce'
import Navigation from '@/mixins/Navigation'
import TierTransformer from '@/assets/js/dexie/transformers/TierTransformer'

export default {
	name: 'SearchTiers',
	mixins: [Navigation],
	props: ['preselected', 'presearch', 'search_value', 'tiers', 'disabled', 'with_tags'],
    data() {
        return {
			options: [],
			searchValue: null,
			isLoading: false,
			debouncedSearch: _debounce(this.search, 300),
		}
	},
	created() {
		this.init_component()
	},
	methods: {
		async init_component() {
			if(this.preselected) {
				this.options = [this.preselected]
				this.searchValue = this.preselected
			}
			else if(this.presearch) {
				this.searchValue = this.presearch
			}
			else if(this.search_value) {
				this.searchValue = {tiers_rs: this.search_value}
				this.onSearch(this.search_value)
			}
		},
		onSearch(search_val) {
			if(search_val) {
				this.$emit("update:search_value", search_val)
			}
			this.debouncedSearch(search_val)
		},
		async search(search_val) {
			this.isLoading = true

			if(search_val == '') {
				this.isLoading = false
				return false
			}

			if(this.$storage.db.tiers) {
				let tiers = await this.$storage.db.t('tiers').then(table => {
					return table.where({
						tiers_archive: 0
					})
				})
				.then(col => {
					return col.filter(elem => {
						const normalizedSearch = search_val.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
						var regex = new RegExp(normalizedSearch, 'gi');
						return (elem.tiers_rs && regex.test(elem.tiers_rs.normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
						|| (elem.tiers_alias && regex.test(elem.tiers_alias.normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
						|| (elem.phone_combine && regex.test(elem.phone_combine.join('-')))
					})
				})
				.then(col => {
					if(this.with_tags){
						return col.limit(30).transform(new TierTransformer('lightWithTags'))
					}
					return col.limit(30).toArray()
				})

				this.options = tiers.sortBy('tiers_rs')
			}

			this.isLoading = false
		},
		onFocus() {
			this.$refs.input.activate()
			this.$refs.input.$refs.search.click()
		},
		async searchTiers(option) {
			if(option != null) {
				// this.options = [option]
				this.searchValue = {tiers_rs: option.tiers_rs, tiers_postalcode: option.tiers_postalcode}
				this.$emit("update:tiers_selected", option)
			}
			else {
				this.$emit("update:tiers_selected", {})
			}
		},
	},
	watch: {
		preselected(val){
			if(val != undefined) {
				this.options = [val]
				this.searchValue = val
			}
		}, 
		presearch(val) {
			if(val) {
				this.searchValue = {tiers_rs: val}
				this.debouncedSearch(val)
			}
		},
		tiers(val) {
			this.options = val
		}
	},
	beforeDestroy() {
		if (this.debouncedSearch && this.debouncedSearch.cancel) {
			this.debouncedSearch.cancel()
		}
	}
}
</script>
